import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Dropdown from './Dropdown';
import classList from '../utils/classList';
import Icon from './Icon';

/**
 * Determines via a vnode is currently "active".
 * Due to changes in Mithril 2, attrs will not be instantiated until AFTER view()
 * is initially called on the parent component, so we can not always depend on the
 * active attr to determine which element should be displayed as the "active child".
 *
 * This is a temporary patch, and as so, is not exported / placed in utils.
 */
function isActive(vnode) {
  if (!vnode || typeof vnode !== 'object' || vnode instanceof Array) return false;
  const tag = vnode.tag;

  // Allow non-selectable dividers/headers to be added.
  if (typeof tag === 'string' && tag !== 'a' && tag !== 'button') return false;
  if ((typeof tag === 'object' || typeof tag === 'function') && 'initAttrs' in tag) {
    tag.initAttrs(vnode.attrs);
  }
  return (typeof tag === 'object' || typeof tag === 'function') && 'isActive' in tag ? tag.isActive(vnode.attrs) : vnode.attrs.active;
}
/**
 * The `SelectDropdown` component is the same as a `Dropdown`, except the toggle
 * button's label is set as the label of the first child which has a truthy
 * `active` prop.
 */
export default class SelectDropdown extends Dropdown {
  static initAttrs(attrs) {
    var _attrs$caretIcon;
    (_attrs$caretIcon = attrs.caretIcon) != null ? _attrs$caretIcon : attrs.caretIcon = 'fas fa-sort';
    super.initAttrs(attrs);
    attrs.className = classList(attrs.className, 'Dropdown--select');
  }
  getButtonContent(children) {
    const activeChild = children.find(isActive);
    let label = activeChild && typeof activeChild === 'object' && 'children' in activeChild && activeChild.children || this.attrs.defaultLabel;
    return [
    // An icon is what identifies the control once there is no room for its
    // label — without one, hiding the label leaves a caret floating on its
    // own with nothing to say what it selects.
    this.attrs.icon ? m(Icon, {
      name: this.attrs.icon,
      noStyleOverride: this.attrs.noStyleOverride,
      className: "Button-icon"
    }) : null, m("span", {
      className: "Button-label"
    }, m("span", {
      className: "Button-labelText"
    }, label)), this.attrs.caretIcon ? m(Icon, {
      name: this.attrs.caretIcon,
      className: "Button-caret"
    }) : null];
  }

  /**
   * Which option is in effect is otherwise conveyed only by a class on the item
   * and by the toggle button borrowing that option's label — neither of which a
   * screen reader announces while moving through the menu.
   *
   * `aria-current` rather than `aria-selected`: the latter is only valid on
   * roles this menu does not claim, and claiming them would mean implementing
   * the whole listbox keyboard contract. Unselected items are left without the
   * attribute rather than given `"false"`, since only one item can be current
   * and the absence says as much.
   */
  getMenu(items) {
    items.forEach(item => {
      // Each item arrives wrapped in the list element `listItems` built around
      // it, so the option itself is the wrapper's child.
      const option = Array.isArray(item == null ? void 0 : item.children) ? item.children[0] : item == null ? void 0 : item.children;
      if (isActive(option)) {
        item.attrs = _objectSpread(_objectSpread({}, item.attrs), {}, {
          'aria-current': 'true'
        });
      }
    });
    return super.getMenu(items);
  }
}
flarum.reg.add('core', 'common/components/SelectDropdown', SelectDropdown);